<script>
import Joi from '@hapi/joi'
import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { CashTransferService } from '@/services'
import { back } from '@/utils/navigation'
import { useLoading } from '@/use/loading'

const Form = () => import('../components/Form.vue')

export default {
  data() {
    return {
      data: {
        datetime: new Date(),
        transferor: '',
        origin: '',
        originMethod: null,
        destination: null,
        destinationMethod: null,
        amount: null,
        ref: '',
        evidences: [],
        note: ''
      },
      isConfirmed: false
    }
  },

  created() {
    this.init()

    this.$watch('data.destination', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        this.data.destinationMethod = null
      }
    })
  },

  mounted() {
    addEventListener('beforeunload', this.handleBeforeunload)
  },

  beforeDestroy() {
    removeEventListener('beforeunload', this.handleBeforeunload)
  },

  methods: {
    init() {
      const transferor = this.$store.getters['auth/userName']
      const origin = `สาขา${this.$store.getters['auth/userBranch']}`

      this.data.transferor = transferor
      this.data.origin = origin
    },

    cancel() {
      back({ name: 'CashTransfer' })
    },

    async confirm() {
      const validate = () => {
        const schema = Joi.object({
          datetime: Joi.date(),
          originMethod: Joi.object(),
          destination: Joi.object(),
          destinationMethod: Joi.object(),
          amount: Joi.number(),
          ref: Joi.string()
        })

        return schema.validateAsync(this.data, { allowUnknown: true })
      }

      const sendData = async () => {
        const data = {
          datetime: this.data.datetime,
          to_branch: this.data.destination.id,
          branch_payment_method: this.data.originMethod.id,
          to_branch_payment_method: this.data.destinationMethod.id,
          amount: this.data.amount,
          ref: this.data.ref,
          attachments: this.data.evidences.map(item => item.id),
          note: this.data.note
        }

        await CashTransferService.create(data)
      }

      try {
        await validate()

        const loading = useLoading()

        try {
          await sendData()

          this.$notify.success('บันทึกข้อมูลเรียบร้อย')

          back({ name: 'CashTransfer' })
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          loading.close()
        }
      } catch (e) {
        this.$message.warning('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
      }
    },

    handleBeforeunload(e) {
      e.preventDefault()
      e.returnValue = ''
    }
  },

  render() {
    return (
      <div>
        <ActionBar>

            <el-button slot="action" onClick={this.cancel}>
            ยกเลิก
            </el-button>
          <el-button slot="action" type="primary" onClick={this.confirm}>
            ยืนยัน
            </el-button>

          <ActionBarTitle>โอนเงิน</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <h1>โอนเงิน</h1>
            <Form
              data={this.data}
              onChange={value => {
                this.data = value
              }}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
